import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import {
  StateService,
  ToolService,
  RouterService,
  ConstructionSite,
  FileTreeComponent,
  NodeItem,
  ConstructionSiteState,
  UploadComponent,
  UploadModalComponent,
} from 'projects/shared/src/public-api';
import { ContextMenuOption } from '../models/context-menu-option';
import { ModalController, Platform } from '@ionic/angular';
import { UploadItem } from '../models/upload-item';
import { ModalRole } from '../models/modal-roles';

@Component({
  selector: 'lib-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss'],
  standalone: false,
})
export class FilesComponent implements OnInit {
  sub: Subscription;
  conSite: ConstructionSite;
  selectedNodeItem: NodeItem;
  detailsOpened: boolean = true;
  @ViewChild(FileTreeComponent) child!: FileTreeComponent;
  currentFolder = signal<NodeItem>({});
  selectedNodeItems: NodeItem[] = [];
  uploadFiles: UploadItem[] = [];

  constructor(
    public state: StateService,
    public tools: ToolService,
    public routerService: RouterService,
    private platform: Platform,
    private modalController: ModalController
  ) {}

  currentFolderNodeItemChanged(item: NodeItem) {
    this.selectedNodeItem = item;
    this.currentFolder.update((n) => item);
  }

  selectedNodeItemsChanged(items: NodeItem[]) {
    this.selectedNodeItems = items;
  }

  ngOnInit() {
    this.sub = this.state.selectedConSite$.subscribe((x) => (this.conSite = x));
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  async openFile(id: string) {
    await this.state.openFile(id, 'document');
  }

  goBack() {
    this.child.goBack();
  }

  setUploadItems(files: UploadItem[]) {
    this.uploadFiles = files;
    if (files.length > 0) {
      this.child.topBreadCrumbDisabled = true;
    } else {
      this.child.topBreadCrumbDisabled = false;
    }
  }

  openFileInput() {
    document.getElementById('file').click();
  }

  async fileInput(files: FileList) {
    const modal = await this.modalController.create({
      component: UploadModalComponent,
      backdropDismiss: false,
      componentProps: {
        fileList: files,
        currentFolder: this.currentFolder,
      },
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
  }
}
